import { QueryKey } from '@tanstack/react-query';

export const kpisKey: QueryKey = ['arrived', 'kpis'];
export const customerCountKey: QueryKey = ['arrived', 'customerCount'];
